import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
  OnInit,
} from '@angular/core';
import {
  ControlContainer,
  FormGroupDirective,
  ReactiveFormsModule,
  UntypedFormGroup,
} from '@angular/forms';
import { PanelComponent } from '@domgen/dgx-fe-components/panel';
import { CheckboxComponent } from '@domgen/dgx-fe-forms/checkbox';
import {
  FormField,
  FormFieldComponent,
  FormFieldDirective,
  FormFieldsetComponent,
  FormRowComponent,
} from '@domgen/dgx-fe-forms/layout';

@Component({
  standalone: true,
  selector: 'checkout-paperless-preference-fieldset',
  templateUrl: './paperless-preference-fieldset.component.html',
  providers: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
    {
      provide: FormFieldsetComponent,
      useExisting: forwardRef(() => PaperlessPreferenceFieldsetComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CheckboxComponent,
    FormFieldDirective,
    FormFieldComponent,
    FormFieldsetComponent,
    FormRowComponent,
    NgIf,
    PanelComponent,
    ReactiveFormsModule,
  ],
})
export class PaperlessPreferenceFieldsetComponent
  extends FormFieldsetComponent
  implements OnInit
{
  @Input() paperlessPreferenceField?: FormField;
  @Input() paperlessPreferenceBanner?: string;

  form!: UntypedFormGroup;

  constructor(protected controlContainer: FormGroupDirective) {
    super();
  }

  ngOnInit(): void {
    this.form = this.controlContainer.form;
  }
}
